import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { isSuperUser } from '../../../utils';

const ManageNotificationsLink = ({ userId, buttonText = 'Manage Notifications', variant = 'outlined', color = 'primary', className = 'mx-auto my-16', ...rest }) => {
    const history = useHistory();
    const canManageNotifications = isSuperUser();

    const handleClick = () => {
        if (userId) {
            history.push(`/notifications-settings/${userId}`);
        }
    };

    if (!canManageNotifications || !userId) {
        return null;
    }

    return (
        <Button onClick={handleClick} variant={variant} color={color} className={className} {...rest}>
            {buttonText}
        </Button>
    );
};

export default ManageNotificationsLink;
